var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.36373 19H6.54567V11.2724L2 7.86331V17.6365C2.00025 18.3894 2.61079 19 3.36373 19Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.455 19H20.6372C21.3903 19 22.0009 18.3895 22.0009 17.6363V7.86307L17.455 11.2724V19Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.455 5.36378V11.2724L22.0006 7.86335V6.04564C22.0006 4.91612 21.0848 4.00031 19.955 4.00031C19.5124 4.00031 19.082 4.14396 18.7279 4.40952L17.455 5.36378Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5459 11.2724V5.36375L12.0003 9.45442L17.4547 5.36349V11.2724L12.0003 15.3631L6.5459 11.2724Z",
    fill: "#EA4335"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00024 6.04536V7.86307L6.54591 11.2724V5.36375L5.27299 4.40924C4.36931 3.73143 3.08728 3.91454 2.40946 4.81821C2.14365 5.17229 2.00024 5.60301 2.00024 6.04536Z",
    fill: "#C5221F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToGmail);
export default __webpack_public_path__ + "static/media/to-gmail.7d0c6344451cbd082a520658c24e059f.svg";
export { ForwardRef as ReactComponent };